<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { KANBAN_LOG_EMPTY_VALUE } from '@entities/kanban-comment'
import { AppText, AppTextLink } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/other'

import { useKanbanLogAssignee } from '../../model/log/use-kanban-log-assignee.hook'
import KanbanLogItemInfo from './KanbanLogItemInfo.vue'

defineOptions({
  name: 'KanbanLogAssignee',
})

const props = withDefaults(defineProps<{
  actor: KanbanLogActor | null
  label?: string
  oldAssignee: KanbanLogActor | null | undefined
  newAssignee: KanbanLogActor | null | undefined
}>(), {
  label: 'change Assignee',
})

const {
  refOldAssignee,
  refNewAssignee,
} = useKanbanLogAssignee({
  oldAssignee: props.oldAssignee,
  newAssignee: props.newAssignee,
})
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      :actor="actor"
      :label="label"
    />
    <div class="kanban-log-field__row">
      <AppTextLink
        v-if="refOldAssignee?.url"
        name="body2-medium"
        color="blue-700"
        :href="refOldAssignee.url"
        target="_blank"
      >
        {{ refOldAssignee.name }}
      </AppTextLink>
      <AppText
        v-else-if="refOldAssignee"
        name="body2"
        color="slate-900"
      >
        {{ refOldAssignee.name }}
      </AppText>
      <AppText
        v-else
        name="body2"
        color="slate-400"
        class="unassigned"
      >
        {{ KANBAN_LOG_EMPTY_VALUE }}
      </AppText>
      <IconContainer>
        <FontAwesomeIcon :icon="faArrowRight" />
      </IconContainer>
      <AppTextLink
        v-if="refNewAssignee?.url"
        name="body2-medium"
        color="blue-700"
        :href="refNewAssignee.url"
        target="_blank"
      >
        {{ refNewAssignee.name }}
      </AppTextLink>
      <AppText
        v-else-if="refNewAssignee"
        name="body2"
        color="slate-900"
      >
        {{ refNewAssignee.name }}
      </AppText>
      <AppText
        v-else
        name="body2"
        color="slate-400"
        class="unassigned"
      >
        {{ KANBAN_LOG_EMPTY_VALUE }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-field.scss" />